// extracted by mini-css-extract-plugin
export var checkboxInput = "styles-module--checkboxInput--bbb19";
export var checkboxLabel = "styles-module--checkboxLabel--d0528";
export var checkmark = "styles-module--checkmark--34251";
export var checkmarkIcon = "styles-module--checkmarkIcon--040ad";